import React, {useState} from "react";
import "./ComponentResultsNoIMG.css";
import DefiniteContestResult from "./DefiniteContestResult";
import gql from "graphql-tag";
import {MonthToText} from "../../../../../../AdminPart/src/Constants";
import QueryContestInfoByID from "../QueryContestInfoByID/QueryContestInfoByID";
// мы получаем AllResults - {_id: уникальный_номер, ContestDate, ContestName, Itog : набор счетов со свойствами} А нам нужно два массива -
// слева где будет {year:[{date: дата, _id: уникальный_номер, active: активность}]}
// справа где {_id: уникальный_номер, Itog : набор счетов со свойствами}
// Если я кликаю на элементе конкурса слева - то меняется ActiveDays -

function ComponentResultsNoIMG(props){
    const [ContestID, setContestID] = useState(props.ContestID);
    const [AllContests, setAllContests] = useState(props.AllContests);
    const [PhoneChangeContestWindow, setPhoneChangeContestWindow] = useState(false);
    const [CurrentYear, setCurrentYear] = useState(props.CurrentYear);

    function DelActive() {setPhoneChangeContestWindow(!PhoneChangeContestWindow);}
    function ChangeActiveContest(year,ContestID) {
        const AllContests = props.AllContests;
        AllContests[props.CurrentYear][props.ContestID].active = false;
        AllContests[CurrentYear][ContestID].active = false;
        AllContests[year][ContestID].active = true;
        setAllContests(AllContests);
        setContestID(ContestID);
        setPhoneChangeContestWindow(!PhoneChangeContestWindow);
        setCurrentYear(year);
    }

    function AllContestsToFormatWeNeed(AllContests,self,lang,TextElement) {
        /**
         * @return {string}
         */
        function DateContestGoodView(ContestDate) {
            const ContestDateArray = ContestDate.split('-');
            let Day = ContestDateArray[1];
            return Day + ' ' + MonthToText(ContestDateArray[0],lang);
        }
        try{
            return Object.keys(AllContests).sort((a, b) => {if (b < a) {return -1} else {return 1}}).map(function(year,index) {
                // console.log('state.AllContests[year]',AllContests[year]);
                const ContestOfThisYear = Object.values(AllContests[year]).map(Contest =>
                    <div className='TraderContestResultsDatesElementOut' key={Contest.ContestDateID}>
                        <div className={(Contest.active ? 'TraderContestResultsDatesElementActive' : 'TraderContestResultsDatesElement')} key={Contest.ContestDateID}
                             role = "button" tabIndex={0} onKeyPress={() => {}} onClick={() => ChangeActiveContest(year,Contest.ContestDateID)}>
                            <div className='TraderContestResultsElementTop' >{DateContestGoodView(Contest.ContestDate)} </div>
                            <div className='TraderContestResultsElementBottom' >{TextElement[Contest.ContestName.split('---')[0]]}</div>

                        </div></div>);
                return <div className='ContestResultsYear' key={index}>
                    <div className='ContestResultsYearTitle'>{year}</div>
                    {ContestOfThisYear}
                </div>
            });
        } catch (e) {
            console.log(e);
        }
    }

        const AllContestsResult = AllContestsToFormatWeNeed(AllContests,this,props.lang,props.data); // Слева перечень конкурсов - мы его преобразуем в формат годы - список.
        return (
            <div className="TraderContestResults">
                <QueryContestInfoByID data={props.data} ContestID={ContestID} lang={props.lang}/>

                <div className={"TraderContestResultsDates " + (PhoneChangeContestWindow ? 'ResultsPhoneVisible': 'ResultsPhoneNoVisible')}>
                    {AllContestsResult}
                </div>
                <div className={(PhoneChangeContestWindow ? 'StandartAllBlack500': 'isNoVisible')}  onClick={() => DelActive()} role="button" tabIndex={0} onKeyPress={() => {}}> </div>
            </div>
        )}

export default ComponentResultsNoIMG